import { __assign, __spreadArray } from "tslib";
import { readFileSync } from 'fs';
import { join } from 'path';
export var buildHtmlTemplate = function (_a) {
    var bundle = _a.bundle, html = _a.html, initialData = _a.initialData, styles = _a.styles, _b = _a.inlineContent, inlineContent = _b === void 0 ? '' : _b, hydrateId = _a.hydrateId, storeId = _a.storeId, _c = _a.cssImports, cssImports = _c === void 0 ? [] : _c, _d = _a.wrapperClassName, wrapperClassName = _d === void 0 ? '' : _d;
    var styleLinks = cssImports.map(function (filePath) { return "<link rel=\"stylesheet\" href=\"".concat(filePath, "\"/>"); });
    var classAttribute = wrapperClassName ? " class=\"".concat(wrapperClassName, "\"") : '';
    return __spreadArray(__spreadArray([
        '<meta charset="utf-8" />',
        '<meta name="viewport" content="width=device-width, initial-scale=1.0" />'
    ], styleLinks, true), [
        styles,
        inlineContent,
        "<script>window['".concat(storeId, "']=").concat(JSON.stringify(__assign({}, initialData)), "</script>"),
        "<div id=\"".concat(hydrateId, "\"").concat(classAttribute, ">").concat(html, "</div>"),
        "<script src=\"".concat(bundle, "\" defer></script>"),
    ], false).join('\n');
};
export var ssrSetup = function (_a) {
    var StyleCollector = _a.StyleCollector, renderer = _a.renderer;
    return function (_a) {
        var Config = _a.Config, Module = _a.Module, ModuleName = _a.ModuleName, version = _a.version, _b = _a.inlineStyles, inlineStyles = _b === void 0 ? [] : _b, _c = _a.cwd, cwd = _c === void 0 ? process.cwd() : _c;
        var html, inlineContent, styles = '';
        if (StyleCollector) {
            var sheet = new StyleCollector();
            html = renderer.renderToString(sheet.collectStyles(Module));
            styles = sheet.getStyleTags();
            sheet.seal();
        }
        else {
            html = renderer.renderToString(Module);
        }
        if (inlineStyles.length > 0) {
            inlineContent = inlineStyles
                .map(function (styleFile) {
                var styleContent = readFileSync(join(cwd, styleFile), 'utf-8');
                return "<style key=\"".concat(styleFile, "\">").concat(styleContent, "</style>");
            })
                .join();
        }
        var bundle = "".concat(Config.build.assetDomain).concat(Config.build.bundlePrefix).concat(ModuleName, ".").concat(version, ".js");
        return {
            bundle: bundle,
            html: html,
            inlineContent: inlineContent,
            styles: styles,
        };
    };
};
export default { buildHtmlTemplate: buildHtmlTemplate, ssrSetup: ssrSetup };
//# sourceMappingURL=export-page-setup.js.map